// extracted by mini-css-extract-plugin
export default {"ressources":"ressources_ressources__5L6VH","content":"ressources_content__z7rdQ","header":"ressources_header__jNgR6","image":"ressources_image__haa+v"};